<template>
  <div class="settings-wrp" :key="$route.path">
    <div class="settings-title">
      {{ t('Integrations') }}
    </div>
    <div v-if="!importResults">
      <custom-integration class="mb-24" />
    </div>
    <div v-if="!importResults" class="settings-columns-wrp mb-24">
      <div class="settings-column">
        <div class="settings-block" v-if="canAccessPage('profile.integrations:voluum')">
          <div class="settings-block__title">
            <div class="settings-block__title-text">{{ t('Import From Voluum') }}</div>
            <div class="settings-block__title-buttons">
              <ui-button
                :text="t('Import Settings')"
                icon="fas fa-file-import"
                button-style="outline-accent"
                @click="importSettings"
              />
            </div>
          </div>
          <div>
            {{ t('Import all your created in Voluum just with one click') }}
            <div class="voluum-login">
              <ui-input
                v-model="form.login"
                class="pr-8"
                :label="t('Login')"
                :placeholder="t('Login')"
                name="first_name"
              />

              <!-- disable autofill because in chrome scroll to form for any click -->
              <ui-input
                v-model="form.password"
                autocomplete="new-password"
                class="pl-8"
                type="password"
                :label="t('Password')"
                :placeholder="t('Password')"
                name="last_name"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="settings-column">
        <div class="settings-block">
          <div class="settings-block__title">
            <div class="settings-block__title-text">{{ t('ClickBank Integration') }}</div>
          </div>
          <div class="mb-8">
            {{
              t(
                'For your convenience, use Secret Key and Instant Notification URL specified below for accurate conversion tracking with ClickBank.',
              )
            }}
          </div>
          <div class="mb-8">
            {{
              t(
                'To perform this action log in to your ClickBank account and follow these steps: Settings menu - My Site sub-menu - Advanced Tools section - Edit.',
              )
            }}
          </div>
          <div class="mb-12">
            {{
              t(
                'Firstly, update Secret Key and press Save Changes button. Update and test Instant Notification URL only after new settings for Secret Key were saved.',
              )
            }}
          </div>
          <ui-copy-input :label="t('ClickBank secret key')" :value="clickBank" />
          <ui-copy-input
            :label="t('ClickBank Instant Notification URL')"
            :value="clickBankInstant"
          />
        </div>
      </div>
    </div>

    <div class="settings-columns-wrp" v-if="importResults">
      <div class="settings-block import-tabs w-100">
        <div class="settings-block__title">
          <div class="settings-block__title-text">{{ t('Import results') }}</div>
        </div>

        <v-tabs
          ref="vTabs"
          class="tabs import-tabs__wrap"
          left
          value="x"
          grow
          hide-slider
          v-model="tab"
        >
          <v-tab :ripple="false" router-link>
            {{ t('Campaigns') }}
          </v-tab>
          <v-tab :ripple="false" router-link>
            {{ t('Traffic Sources') }}
          </v-tab>
          <v-tab :ripple="false" router-link>
            {{ t('Flows') }}
          </v-tab>
          <v-tab :ripple="false" router-link>
            {{ t('Landings') }}
          </v-tab>
          <v-tab :ripple="false" router-link>
            {{ t('Offers') }}
          </v-tab>
          <v-tab :ripple="false" router-link>
            {{ t('Affiliate Networks') }}
          </v-tab>
          <v-tab :ripple="false" router-link>
            {{ t('Final step') }}
          </v-tab>
        </v-tabs>

        <div class="w100 import-tabs__table">
          <div class="import-tabs__table-header" v-if="tab < 6">
            <ui-button :text="t('Select / Deselect all')" @click="selectAll(tabs[tab])" />
          </div>

          <v-tabs-items>
            <v-tab-item
              v-if="tab < 6"
              v-for="item in items[tabs[tab]]"
              class="d-flex import-tabs__table-body cursor-pointer"
              :key="item.data"
              @click="select(tabs[tab], item)"
              :value="tab"
            >
              <div class="import-tabs__table-body-check">
                <ui-checkbox
                  class="pt-8 pb-8 pointer-events-none"
                  v-model="item.selected"
                />
              </div>
              <div class="d-flex align-items-center">
                <span>
                  {{ item.voluumName }}
                  <span v-if="item.$depends" style="float: right">
                    <b>[ depends on {{ item.$depends }} ]</b>
                  </span>
                </span>
              </div>
            </v-tab-item>
            <v-tab-item
              class="d-flex import-tabs__table-body"
              v-if="tab === 6"
              :value="tab"
            >
              <div class="error-block" v-if="!length">
                {{ t('Nothing is selected for import') }}
              </div>
              <div class="table-wrap" :class="{ 'selected-list': length }" v-if="length">
                <div class="success-block" v-if="length">
                  <!--                          task BMB-605-->
                  {{
                    t('Import process is ready to start {0} items to import', [length])
                  }}
                </div>
                <div class="selected-items">
                  <template v-for="key in tabs">
                    <div
                      :key="key"
                      v-if="selected[key]?.length"
                      class="selected-items__out"
                    >
                      <h4>{{ key }}</h4>
                      <div
                        class="import-tabs__table-body"
                        v-for="item in selected[key]"
                        :key="item.id"
                      >
                        <div class="import-tabs__table-body-check">
                          <ui-icon
                            size="12"
                            :color="$colors.black"
                            icon="far fa-circle"
                          />
                          <ui-icon size="12" :color="$colors.black" icon="fas fa-check" />
                        </div>
                        <div
                          class="d-flex align-items-center import-tabs__table-body-text"
                        >
                          <span>{{ item.voluumName }}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </v-tab-item>
          </v-tabs-items>

          <div v-if="tab < 6" class="import-tabs__table-footer">
            <ui-button :text="t('Select / Deselect all')" @click="selectAll(tabs[tab])" />
          </div>
        </div>

        <div class="mt-12 d-flex justify-content-between">
          <ui-button
            class="ml-0"
            :text="t('Cancel')"
            icon="fas fa-times"
            @click="importResults = false"
          />

          <ui-button
            v-if="tab < 6"
            class="mr-0"
            :text="t('Next')"
            icon="fas fa-arrow-right"
            button-style="accent"
            @click="nextTab"
          />

          <ui-button
            v-if="tab === 6 && length"
            class="mr-0"
            :text="t('Start Import')"
            icon="far fa-file-import"
            button-style="accent"
            :loading="importing"
            @click="doImport"
          >
            {{ t('Start Import') }}
          </ui-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import _ from 'lodash';
import CustomIntegration from './custom-integrations/custom-integrations.vue';
import { postImportSettingsApiRequest } from '@/services/api/import-api';
import { populateTrackingDomainsStoreCacheApiRequest } from '@/services/api/api-services/domains';
import { postEntityCreateApiRequest } from '@/services/api/entity-api';
import { useAcl, useColors, useI18n } from '@/composables';
import { useStore } from '@/store';
import { $emitter } from '@/services/emitter';

type ImportItem = {
  id: string;
  name: string;
  selected?: boolean;
  data?: string;
  voluumName?: string;
  trafficSourceId?: string;
  uses?: {
    flow?: string;
    offers?: string[];
    landings?: string[];
    affiliateNetwork?: string;
  };
  $depends?: string;
};

type ImportItemsByType = Record<string, ImportItem[]>;
type SelectedByType = Record<string, ImportItem[]>;
type IdReplaceMap = Record<string, string>;

const store = useStore();
const { t } = useI18n();
const $colors = useColors();
const { canAccessPage } = useAcl();

const getDefaultForm = () => ({
  login: '',
  password: '',
});

const importResults = ref(false);
const form = ref(getDefaultForm());
const clickBank = ref('');
const clickBankInstant = ref('');
const importing = ref(false);
const selected = ref<SelectedByType>({});
const items = ref<ImportItemsByType>({});
const tabs = [
  'campaigns',
  'trafficSources',
  'flows',
  'landings',
  'offers',
  'affiliateNetworks',
];
const tab = ref(0);

const appendRelated = (item: ImportItem) => {
  if (item.uses && item.uses.flow) {
    (items.value.flows || []).forEach(flow => {
      if (flow.id !== item.uses?.flow) return;
      selected.value.flows = (selected.value.flows || []).filter(
        selectedItem => selectedItem.id !== flow.id,
      );
      flow.selected = true;
      flow.$depends = item.name;
      selected.value.flows.push(flow);
      appendRelated(flow);
    });
  }

  if (item.trafficSourceId) {
    (items.value.trafficSources || []).forEach(trafficSource => {
      if (trafficSource.id !== item.trafficSourceId) return;
      selected.value.trafficSources = (selected.value.trafficSources || []).filter(
        selectedItem => selectedItem.id !== trafficSource.id,
      );
      trafficSource.selected = true;
      trafficSource.$depends = item.name;
      selected.value.trafficSources.push(trafficSource);
      appendRelated(trafficSource);
    });
  }

  if (item.uses && item.uses.offers) {
    (items.value.offers || []).forEach(offer => {
      if (!item.uses?.offers?.includes(offer.id)) return;
      selected.value.offers = (selected.value.offers || []).filter(
        selectedItem => selectedItem.id !== offer.id,
      );
      offer.selected = true;
      offer.$depends = item.name;
      selected.value.offers.push(offer);
      appendRelated(offer);
    });
  }

  if (item.uses && item.uses.landings) {
    (items.value.landings || []).forEach(landing => {
      if (!item.uses?.landings?.includes(landing.id)) return;
      selected.value.landings = (selected.value.landings || []).filter(
        selectedItem => selectedItem.id !== landing.id,
      );
      landing.selected = true;
      landing.$depends = item.name;
      selected.value.landings.push(landing);
      appendRelated(landing);
    });
  }

  if (item.uses && item.uses.affiliateNetwork) {
    (items.value.affiliateNetworks || []).forEach(affiliateNetwork => {
      if (affiliateNetwork.id !== item.uses?.affiliateNetwork) return;
      selected.value.affiliateNetworks = (selected.value.affiliateNetworks || []).filter(
        selectedItem => selectedItem.id !== affiliateNetwork.id,
      );
      affiliateNetwork.selected = true;
      affiliateNetwork.$depends = item.name;
      selected.value.affiliateNetworks.push(affiliateNetwork);
      appendRelated(affiliateNetwork);
    });
  }
};

watch(tab, tabValue => {
  if (tabValue !== 6) return;
  _.forOwn(selected.value, selectedByType => {
    _.forEach(selectedByType || [], selectedItem => {
      appendRelated(selectedItem);
    });
  });
});

onMounted(async () => {
  store.setLoading(true);
  try {
    if (!store.trackingDomains.isUploaded) {
      await populateTrackingDomainsStoreCacheApiRequest();
    }
    const notCustomTrackingDomains = store.trackingDomains.data.filter(
      domainItem => !domainItem.custom,
    );
    clickBank.value = String(store.user.subdomain || '').toUpperCase();
    if (notCustomTrackingDomains[0]) {
      const protocol = notCustomTrackingDomains[0].httpsAvailable ? 'https' : 'http';
      clickBankInstant.value = `${protocol}://${notCustomTrackingDomains[0].domain}/clickbank-ins`;
    }
  } finally {
    store.setLoading(false);
  }
});

const importSettings = () => {
  store.setLoading(true);
  postImportSettingsApiRequest('voluum', form.value)
    .then((data: ImportItemsByType) => {
      importResults.value = true;
      selected.value = {};
      items.value = data;
      tab.value = 0;
      form.value = getDefaultForm();
    })
    .catch(() => {
      form.value.password = '';
      $emitter.emit('toast-error', t('Email / Password is invalid'));
    })
    .finally(() => {
      store.setLoading(false);
    });
};

const select = (type: string, item: ImportItem) => {
  selected.value[type] = selected.value[type] || [];
  const found = selected.value[type].find(selectedItem => selectedItem.id === item.id);
  if (found) {
    selected.value[type] = selected.value[type].filter(
      selectedItem => selectedItem.id !== item.id,
    );
    item.selected = false;
    return;
  }
  item.selected = true;
  selected.value[type].push(item);
};

const selectAll = (type: string) => {
  if (selected.value[type] && items.value[type].length === selected.value[type].length) {
    selected.value[type] = [];
    items.value[type].forEach(item => {
      item.selected = false;
    });
    return;
  }
  selected.value[type] = items.value[type];
  items.value[type].forEach(item => {
    item.selected = true;
  });
};

const length = computed(() => {
  if (tab.value < 0) return 0;
  return tabs
    .map(type => {
      const selectedItems = selected.value[type];
      return selectedItems ? selectedItems.length : 0;
    })
    .reduce((acc, item) => acc + item, 0);
});

const nextTab = () => {
  if (tab.value <= 5) {
    tab.value = tab.value + 1;
  }
};

const replaceByMap = (data: ImportItem, replaceIds: IdReplaceMap): ImportItem => {
  let newValue = JSON.stringify(data);
  _.forOwn(replaceIds, (to, from) => {
    newValue = newValue.split(from).join(to);
  });
  return JSON.parse(newValue);
};

const importSelection = async (
  endpoint: string,
  selection: ImportItem[],
  replaceIds: IdReplaceMap,
  shouldReplaceIds = false,
) => {
  const tasks = selection.map(data => {
    const payload = shouldReplaceIds ? replaceByMap(data, replaceIds) : data;
    return postEntityCreateApiRequest<{ id: string }>(endpoint, payload).then((created) => {
      replaceIds[data.id] = created.id;
    });
  });
  await Promise.all(tasks);
};

const doImport = async () => {
  importing.value = true;
  try {
    const replaceIds: IdReplaceMap = {};

    const selectedAffiliateNetworks = selected.value.affiliateNetworks;
    if (selectedAffiliateNetworks?.length) {
      await importSelection('affiliate-networks', selectedAffiliateNetworks, replaceIds);
    }

    const selectedLandings = selected.value.landings;
    if (selectedLandings?.length) {
      await importSelection('landings', selectedLandings, replaceIds);
    }

    const selectedOffers = selected.value.offers;
    if (selectedOffers?.length) {
      await importSelection('offers', selectedOffers, replaceIds, true);
    }

    const selectedTrafficSources = selected.value.trafficSources;
    if (selectedTrafficSources?.length) {
      await importSelection('traffic-sources', selectedTrafficSources, replaceIds);
    }

    const selectedFlows = selected.value.flows;
    if (selectedFlows?.length) {
      await importSelection('flows', selectedFlows, replaceIds, true);
    }

    const selectedCampaigns = selected.value.campaigns;
    if (selectedCampaigns?.length) {
      await importSelection('campaigns', selectedCampaigns, replaceIds, true);
    }
  } catch {
    importing.value = false;
    $emitter.emit(
      'toast-error',
      t('The Import Error occurred. Please contact Support Team for assistance.'),
    );
    return;
  }

  importing.value = false;
  tab.value = 0;
  _.forEach(tabs, type => {
    (items.value?.[type] || []).forEach(item => {
      item.selected = false;
    });
  });
  $emitter.emit('toast-success', t('Data imported successfully.'));
};
</script>

<style lang="scss" scoped>
.voluum-login {
  padding-top: 12px;
  display: flex;
  flex-wrap: wrap;
}

.voluum-login > div {
  flex: 1;
}
</style>
<style lang="scss">
.import-tabs {
  .v-tab.v-tab.v-btn {
    height: 36px;
  }

  .v-tab {
    color: var(--color-green);
    text-transform: capitalize;
    padding: 0 8px;

    .v-btn__content {
      font-size: 15px;
    }
  }

  .v-tab--selected {
    color: var(--color-white);
    background: var(--color-green);
  }

  .v-slide-group__content {
    flex: initial;
  }

  .v-tabs--density-default {
    height: 42px;
  }
}

.import-tabs__table {
  .import-tabs__table-header {
    border: 1px solid var(--color-gray10);
    border-bottom: 0 !important;
  }
  .v-window__container {
    height: auto !important;
  }
  .v-btn {
    height: 30px !important;
  }
  .import-tabs__table-body {
    // flex-direction: column;
    border: 1px solid var(--color-gray10);
    > div {
      padding: 4px 2px 4px 8px;
    }
    &:nth-child(2n + 1) {
      background: var(--color-bluelight);
    }
    &-check {
      flex-grow: 0 !important;
      flex-shrink: 0 !important;

      border-right: 0 !important;
      .v-input {
        justify-content: center;
        padding-top: 0;
        position: relative;
        top: 6px;
      }
    }
    .selected-list {
      border: none;
      background: var(--color-white);
      padding: 0;
      width: 100%;
      .selected-items {
        h4 {
          margin: 8px 0 4px;
          padding-top: 8px;
          font-size: 17px;
          font-weight: normal;
          text-transform: capitalize;
        }
        .selected-items__out {
          .import-tabs__table-body:nth-child(2n) {
            background: var(--color-bluelight);
          }
        }
        .import-tabs__table-body {
          display: flex;
          &-check {
            width: 41px;
            height: 46px;
            display: flex;
            justify-content: center;
          }
          &-text {
            width: 100%;
            span {
              white-space: pre-wrap;
            }
          }
        }
        .fa-check {
          display: none;
        }
        .import-tabs__table-body.success {
          background: var(--color-green50) !important;

          .fa-check {
            display: flex;
          }
          .fa-circle {
            display: none;
          }
        }
        .import-tabs__table-body.error {
          background: var(--color-pink) !important;
        }
      }
    }
    .error-block {
      border: none !important;
      background: var(--color-red);
      color: var(--color-white);
      padding: 16px;
      width: 100%;
    }
    .success-block {
      background: var(--color-green);
      color: var(--color-white);
      padding: 16px;
      width: 100%;
    }
  }
  .import-tabs__table-footer {
    border: 1px solid var(--color-gray10);
    border-top: 0 !important;
  }
}
</style>
